import React, { useState } from "react";
import API from "../api";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useNavigate } from "react-router-dom";

import "../css/style.css";

const AdminLogin = () => {
    const navigate = useNavigate();

    const [form, setForm] = useState({
        email: "",
        password: ""
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const res = await API.post("/admin/login", form);

            toast.success(res.data.message || "Login successful");

            // save admin
            localStorage.setItem("admin", JSON.stringify(res.data.admin));
            localStorage.setItem("token", res.data.token);

            setTimeout(() => {
                navigate("/dashboard");
            }, 1500);

        } catch (err) {

            const msg = err.response?.data?.message;

            // If admin not exists → go to setup page
            if (msg === "Admin not found") {
                toast.error("No admin found! Please create account.");

                setTimeout(() => {
                    navigate("/setup");
                }, 1500);
            } else {
                toast.error(msg || "Login failed");
            }
        }
    };

    return (
        <div className="login-container">

            <div className="login-box">
                <h2>LOGIN</h2>

                <form onSubmit={handleLogin}>

                    <input
                        type="email"
                        name="email"
                        placeholder="Email address"
                        onChange={handleChange}
                        required
                    />

                    <input
                        type="password"
                        name="password"
                        placeholder="Password"
                        onChange={handleChange}
                        required
                    />

                    <button type="submit">SIGN IN</button>

                    {/* Signup Link */}
                    {/* <p className="signup-link">
                        Don't have an account?{" "}
                        <span onClick={() => navigate("/setup")}>
                            Sign Up
                        </span>
                    </p> */}

                </form>
            </div>

            {/* Toast */}
            <ToastContainer position="top-right" autoClose={3000} />
        </div>
    );
};

export default AdminLogin;